/* One delegated handler also covers AJAX filters, load-more and editor renders.
   Currency formatting and instalment arithmetic are performed in Liquid. */
(() => {
  if (window.deeplayCollectionPaymentsReady) return;
  window.deeplayCollectionPaymentsReady = true;
  function selectProvider(logo) {
    const card = logo.closest('[data-dp-instalments]');
    if (!card) return;
    const provider = logo.dataset.dpProvider;
    card.querySelectorAll('[data-dp-provider]').forEach((item) => {
      item.setAttribute('aria-checked', String(item === logo));
      item.tabIndex = item === logo ? 0 : -1;
    });
    card.querySelectorAll('[data-dp-payment-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.dpPaymentPanel !== provider;
    });
  }
  document.addEventListener('click', (event) => {
    const videoToggle = event.target.closest('[data-dp-video-toggle]');
    if (videoToggle) {
      const video = videoToggle.closest('.dp-promotion-grid-item')?.querySelector('.dp-promo-video');
      if (!video) return;
      if (video.paused || video.ended) {
        video.play().catch(() => updateVideoControl(video));
      } else video.pause();
      return;
    }
    const logo = event.target.closest('[data-dp-provider]');
    if (logo) selectProvider(logo);
  });
  document.addEventListener('keydown', (event) => {
    const logo = event.target.closest('[data-dp-provider]');
    if (!logo) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      selectProvider(logo);
      return;
    }
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
    const group = logo.closest('[data-dp-instalments]');
    if (!group) return;
    event.preventDefault();
    const logos = Array.from(group.querySelectorAll('[data-dp-provider]'));
    let index = logos.indexOf(logo);
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = logos.length - 1;
    else index = (index + (['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1) + logos.length) % logos.length;
    selectProvider(logos[index]);
    logos[index].focus();
  });
  function updateVideoControl(video) {
    const toggle = video.closest('.dp-promotion-grid-item')?.querySelector('[data-dp-video-toggle]');
    if (!toggle) return;
    const playing = !video.paused && !video.ended;
    toggle.setAttribute('aria-label', playing ? 'Pause promotion video' : 'Play promotion video');
    toggle.querySelector('[data-dp-video-label]').textContent = playing ? 'Pause' : 'Play';
  }
  // Media events do not bubble; capture covers videos added by load more too.
  ['play', 'pause', 'ended'].forEach((type) => {
    document.addEventListener(type, (event) => {
      if (event.target.matches?.('.dp-promo-video')) updateVideoControl(event.target);
    }, true);
  });
  document.querySelectorAll('.dp-promo-video').forEach(updateVideoControl);
})();